import apiClient from '../utils/apiClient';

const BASE_PATHS = {
  project: '/api/projects',
  lead: '/api/leads',
};

function basePath(entityType) {
  const base = BASE_PATHS[entityType];
  if (!base) throw new Error(`Unknown entity type: ${entityType}`);
  return base;
}

export async function getActivity(entityType, entityId, { limit, before } = {}) {
  const response = await apiClient.get(`${basePath(entityType)}/${entityId}/activity`, {
    params: { limit, before },
  });
  return response.data.activity;
}

export async function addComment(entityType, entityId, commentText) {
  const response = await apiClient.post(`${basePath(entityType)}/${entityId}/comments`, {
    comment_text: commentText,
  });
  return response.data.activity;
}

export async function listFiles(entityType, entityId) {
  const response = await apiClient.get(`${basePath(entityType)}/${entityId}/files`);
  return response.data.files;
}

export async function uploadFile(entityType, entityId, file) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiClient.post(`${basePath(entityType)}/${entityId}/files`, formData);
  return response.data.file;
}

export async function deleteFile(entityType, entityId, fileId) {
  const response = await apiClient.delete(`${basePath(entityType)}/${entityId}/files/${fileId}`);
  return response.data;
}
